import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./header.css";
import ThemeSelect from "../themeselect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";

import ImageLogo from "../../assets/images/cotmarsh-tannery-logo.webp";

function Header({ currentPage }) {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuItems, setMenuItems] = useState([
    {
      id: 1,
      path: "/churchill-fellowship",
      name: "Churchill Fellowship",
    },
    {
      id: 2,
      path: "/survey",
      name: "Survey",
    },
    {
      id: 3,
      path: "/support",
      name: "Support",
    },
    {
      id: 4,
      path: "#",
      name: "About Us",
      subMenu: [
        {
          id: 1,
          name: "Our Story",
          path: "/our-story",
          description: "Learn about our journey",
          image: require("../../assets/images/menu/our-story.webp"),
        },
        // {
        //   id: 3,
        //   name: "UK Tannery Visits",
        //   path: "/blog/uk",
        //   description: "Explore UK tanneries",
        //   image: require("../../assets/images/menu/uk-tanneries.webp"),
        // },
        {
          id: 2,
          name: "Media",
          path: "/articles/",
          description: "View our media coverage",
          image: require("../../assets/images/menu/articles.webp"),
        },
        {
          id: 3,
          name: "Newsletter Archive",
          path: "/newsletter/",
          description: "Browse past newsletters",
          image: require("../../assets/images/menu/newsletter.webp"),
        },
        {
          id: 4,
          name: "Contact Us",
          path: "/contact-us",
          description: "Get in touch with us",
          image: require('../../assets/images/menu/contact.webp'),
        },
      ],
    },
  ]);

  function toggleMobileMenu() {
    setMenuOpen((prevState) => !prevState);
  }

  function toggleSubMenu(id) {
    setActiveMenu((prevState) => (prevState === id ? null : id));
  }

  // Add resize event listener to remove the "show" class
  useEffect(() => {
    function handleResize() {
      if (isMenuOpen) {
        setMenuOpen(false); // Close the menu
      }
    }

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMenuOpen]);

  const renderMenuItem = (item) => {
    if (item.subMenu) {
      return (
        <li key={item.id} className="menu-item">
          <NavLink
            to={item.path}
            {...(!isMenuOpen && {
              onMouseEnter: () => setActiveMenu(item.id),
              onMouseLeave: () => setActiveMenu(null),
            })}
            
            onClick={(e) => {
              e.preventDefault();
              toggleSubMenu(item.id);
            }}
          >
            {item.name}
            {isMenuOpen && <FontAwesomeIcon icon={faChevronRight} className="submenu-icon" /> }
          </NavLink>
          {activeMenu === item.id && (
            <ul 
              {...(!isMenuOpen && {
                onMouseEnter: () => setActiveMenu(item.id),
                onMouseLeave: () => setActiveMenu(null),
              })}
              className={cx("sub-menu", { "mobile-submenu": isMenuOpen }) 
            }>
              {item.subMenu.map((subItem) => (
                <li key={subItem.id} className="sub-menu-item">
                  <NavLink 
                    onClick={() => {setMenuOpen(false); setActiveMenu(null)}} 
                    to={subItem.path} 
                  >
                    {!isMenuOpen && <img src={subItem.image} alt={subItem.name} />}                  
                    {subItem.name}
                    {!isMenuOpen && <p>{subItem.description}</p>}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    }

    return (
      <li key={item.id} className="menu-item">
        <NavLink 
          onClick={() => setMenuOpen(false)} 
          to={item.path}
        >
          <span>{item.name}</span>
        </NavLink>
      </li>
    );
  };

  return (
    <>
      <header className={cx("floating-header", { "expand" : activeMenu })} >
        <nav>
          <NavLink
            id="open"
            title="Mobile menu"
            to="#"
            className="menuToggle"
            onClick={toggleMobileMenu}
            aria-expanded={isMenuOpen}
            aria-controls="menuItems"
          >
            <span>Menu</span>
            <FontAwesomeIcon icon={isMenuOpen ? faXmark : faBars} />
          </NavLink>
          <div className={cx("menu", { show: isMenuOpen })}>
            <div id="logo" className="logo">
              <div className="logo-circle-container">
                <div className="logo-circle-top"></div>
                <div className="logo-circle-middle">
                  <a href="/">
                    <img src={ImageLogo} alt="Cotmarsh Tannery CIC Logo" />
                  </a>
                </div>
                <div className={cx("logo-circle-bottom", { "expand" : activeMenu && !isMenuOpen })}></div>
              </div>
            </div>

            <ul className="menuItems">
              {menuItems.slice(0, 2).map(renderMenuItem)}
            </ul>

            <ul className="menuItems">
              {menuItems.slice(2).map(renderMenuItem)}
              <li id="themeselect" onClick={() => setMenuOpen(false)}><ThemeSelect />
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <noscript>You need to enable JavaScript to run this app.</noscript>
    </>
  );
}

export default Header;

function Hero({ title, subtitle, logo, anchors }) {
  return (
    <>
      {/* start slider */}
      <div className="slider_bg">
        <div className="wrap">
          <div className="slider" id="home">
            <div className="slider_text">
              <h1>{title}</h1>
              <div>{subtitle}</div>
              {anchors && anchors.length > 0 && (
                <div className="slider_btn">
                  {anchors.map(({ id, text }) => (
                    <a href={"#" + id} key={id} className="button">
                      {text}
                    </a>
                  ))}
                </div>
              )}
              {logo}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { Hero };
